/**
 * @generated SignedSource<<c0144e78da0c6cdc0ffcca91fc279aa1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportPathwayProgressFragment$data = {
  readonly completedAt: string | null;
  readonly pathwayMemberProgressReport: {
    readonly currentGroup: number;
    readonly currentGroupCompletedProducts: number;
    readonly currentGroupTotalProducts: number;
    readonly totalGroups: number;
  } | null;
  readonly " $fragmentType": "AdminMembersReportPathwayProgressFragment";
};
export type AdminMembersReportPathwayProgressFragment$key = {
  readonly " $data"?: AdminMembersReportPathwayProgressFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportPathwayProgressFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminMembersReportPathwayProgressFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PathwayMemberProgressReportResponse",
      "kind": "LinkedField",
      "name": "pathwayMemberProgressReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalGroups",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentGroup",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentGroupTotalProducts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentGroupCompletedProducts",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductMembership",
  "abstractKey": null
};

(node as any).hash = "54a2144bdebdbd25f3e617ddfac5ea1f";

export default node;
